// extracted by mini-css-extract-plugin
export default {"root":"popup_root__hBlfL","buttons":"popup_buttons__2fkJa","add":"popup_add__ixgQR","cancel":"popup_cancel__xQ3aP"};